import { useEffect } from 'react';

const useClickOutside = (
  ref,
  onOutside,
  { active = true, closeOnEscape = false } = {}
) => {
  useEffect(() => {
    if (!active) return undefined;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    let handleKeyDown;
    if (closeOnEscape) {
      handleKeyDown = (event) => {
        if (event.key === 'Escape') onOutside();
      };
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (handleKeyDown) document.removeEventListener('keydown', handleKeyDown);
    };
  }, [active, closeOnEscape, onOutside, ref]);
};

export default useClickOutside;
